import {
  Directive,
  ElementRef,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  Renderer2
} from '@angular/core';

@Directive({
  selector: '[appInput]',
  standalone: false
})
export class InputDirective implements OnInit, OnChanges {
  @Input() appInput: '' | 'default' = 'default';
  @Input() noIcon = false;
  @Input() border = false;
  @Input() hasError = false;

  private previousClasses: string[] = [];

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.updateClasses();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appInput'] || changes['noIcon'] || changes['border'] || changes['hasError']) {
      this.updateClasses();
    }
  }

  private updateClasses(): void {
    // Remove previous classes
    this.previousClasses.forEach((cls) => {
      this.renderer.removeClass(this.el.nativeElement, cls);
    });

    // Calculate new classes
    const classes = this.getClasses();

    // Add new classes
    classes.forEach((cls) => {
      this.renderer.addClass(this.el.nativeElement, cls);
    });

    // Store for next update
    this.previousClasses = classes;
  }

  private getClasses(): string[] {
    const classes: string[] = ['input-box'];

    if (this.noIcon) {
      classes.push('input-box--no-icon');
    }

    if (this.border) {
      classes.push('input-box--border');
    }

    if (this.hasError) {
      classes.push('error-box');
    }

    return classes;
  }
}
